import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { RemoveDevicesFromScheduledShowDocument } from './remove-devices.generated';

export const useRemoveDevicesFromScheduledShow = (
  options: ApiOptions<typeof RemoveDevicesFromScheduledShowDocument> = {},
) => {
  const { t } = useTranslation();
  return useMutation(RemoveDevicesFromScheduledShowDocument, {
    ...useNotifications(RemoveDevicesFromScheduledShowDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.scheduled_show.update_success'),
    }),
    ...options,
  });
};
